import { ProjectType, useBackendApi } from 'nekst-api';

type ServiceProviderLink = {
  personId: number
  serviceProviderGroupId: number
}

export type DefaultPortalConfiguration = {
  isEnabled: boolean
  title: string
  showAllTransactionParties: boolean
  detailFieldsIds: number[]
  serviceProvidersLinks: ServiceProviderLink[]
  documentLabelsIds: number[]
}

export type ShortDefaultPortalConfiguration = {
  projectType: ProjectType,
  setupArea: {
    setupAreaId: number,
    name: string,
  }
}

export default function useDefaultPortalConfigurationService() {

  const backendApi = useBackendApi();

  const getPortalConfiguration = async (projectType: ProjectType, setupAreaId?: string | number) => {
    const query = setupAreaId ? `?setupAreaId=${setupAreaId}` : '';

    return await backendApi.get('/settings/clientportal/' + projectType + '/configuration' + query) as DefaultPortalConfiguration;
  };

  const updatePortalConfiguration = async (projectType: ProjectType, request: DefaultPortalConfiguration, setupAreaId?: string | number) => {
    const query = setupAreaId ? `?setupAreaId=${setupAreaId}` : '';
    return await backendApi.put('/settings/clientportal/' + projectType + '/configuration' + query, request) as DefaultPortalConfiguration;
  };

  const getAllConfigurations = async (projectType: ProjectType) => {
    return await backendApi.get('/settings/clientportal/' + projectType + '/configurations') as ShortDefaultPortalConfiguration[];
  }

  return {
    getPortalConfiguration,
    updatePortalConfiguration,
    getAllConfigurations,
  };
}
